// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Contact
--------------------------------------------------------------*/

.contact-heading {
    color: white;
    text-align: center;
}
.contact {
    color: white;
}

.contact-container {
    margin-top: 200px;
    position: fixed; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001; 
    width: 50%; 
    margin: 0; 
}
  .contact .php-email-form {
    padding: 30px;
    background: rgba(7, 7, 7, 0.877)
  }
  
  .contact .php-email-form .error-message {
    display: none;
    background: rgba(255, 255, 255, 0.08);
    background: #ed3c0d;
    text-align: left;
    padding: 15px;
    font-weight: 600;
  }
  
  .contact .php-email-form .error-message br+br {
    margin-top: 25px;
  }
  
  .contact .php-email-form .sent-message {
    display: none;
    background: rgba(255, 255, 255, 0.08);
    background: #18d26e;
    text-align: center;
    padding: 15px;
    font-weight: 600;
  }
  
  .contact .php-email-form .loading {
    display: none;
    background: rgba(255, 255, 255, 0.08);
    text-align: center;
    padding: 15px;
  }
  
  .contact .php-email-form .loading:before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    margin: 0 10px -6px 0;
    border: 3px solid #18d26e;
    border-top-color: #eee;
    animation: animate-loading 1s linear infinite;
  }
  
  .contact .php-email-form input,
  .contact .php-email-form textarea {
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.08);
    border: 0;
    transition: 0.3s;
    color: #fff;
  }
  
  .contact .php-email-form input:focus,
  .contact .php-email-form textarea:focus {
    background-color: rgba(255, 255, 255, 0.11);
  }
  
  .contact .php-email-form input::placeholder,
  .contact .php-email-form textarea::placeholder {
    color: rgba(255, 255, 255, 0.3);
    opacity: 1;
  }
  
  .contact .php-email-form input {
    padding: 10px 15px;
  }
  
  .contact .php-email-form textarea {
    padding: 12px 15px;
  }
  
  .contact .php-email-form button[type=submit] {
    background: #18d26e;
    border: 0;
    padding: 10px 30px;
    color: #080808;
    transition: 0.4s;
    border-radius: 4px;
    margin-top: 10px;
  }
  
  .contact .php-email-form button[type=submit]:hover {
    background: #15bb62;
  }
  .submit-status{
    color: green;
    text-align: center;
    font-size: 25px;
  }
  
  @keyframes animate-loading {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }

`, "",{"version":3,"sources":["webpack://./src/styles/Contact.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,UAAU;IACV,SAAS;AACb;EACE;IACE,aAAa;IACb;EACF;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,6CAA6C;EAC/C;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,2CAA2C;EAC7C;;EAQA;;IAEE,+BAA+B;IAC/B,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":["/*--------------------------------------------------------------\n# Contact\n--------------------------------------------------------------*/\n\n.contact-heading {\n    color: white;\n    text-align: center;\n}\n.contact {\n    color: white;\n}\n\n.contact-container {\n    margin-top: 200px;\n    position: fixed; \n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1001; \n    width: 50%; \n    margin: 0; \n}\n  .contact .php-email-form {\n    padding: 30px;\n    background: rgba(7, 7, 7, 0.877)\n  }\n  \n  .contact .php-email-form .error-message {\n    display: none;\n    background: rgba(255, 255, 255, 0.08);\n    background: #ed3c0d;\n    text-align: left;\n    padding: 15px;\n    font-weight: 600;\n  }\n  \n  .contact .php-email-form .error-message br+br {\n    margin-top: 25px;\n  }\n  \n  .contact .php-email-form .sent-message {\n    display: none;\n    background: rgba(255, 255, 255, 0.08);\n    background: #18d26e;\n    text-align: center;\n    padding: 15px;\n    font-weight: 600;\n  }\n  \n  .contact .php-email-form .loading {\n    display: none;\n    background: rgba(255, 255, 255, 0.08);\n    text-align: center;\n    padding: 15px;\n  }\n  \n  .contact .php-email-form .loading:before {\n    content: \"\";\n    display: inline-block;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    margin: 0 10px -6px 0;\n    border: 3px solid #18d26e;\n    border-top-color: #eee;\n    animation: animate-loading 1s linear infinite;\n  }\n  \n  .contact .php-email-form input,\n  .contact .php-email-form textarea {\n    border-radius: 0;\n    box-shadow: none;\n    font-size: 14px;\n    background: rgba(255, 255, 255, 0.08);\n    border: 0;\n    transition: 0.3s;\n    color: #fff;\n  }\n  \n  .contact .php-email-form input:focus,\n  .contact .php-email-form textarea:focus {\n    background-color: rgba(255, 255, 255, 0.11);\n  }\n  \n  .contact .php-email-form input::-moz-placeholder,\n  .contact .php-email-form textarea::-moz-placeholder {\n    color: rgba(255, 255, 255, 0.3);\n    opacity: 1;\n  }\n  \n  .contact .php-email-form input::placeholder,\n  .contact .php-email-form textarea::placeholder {\n    color: rgba(255, 255, 255, 0.3);\n    opacity: 1;\n  }\n  \n  .contact .php-email-form input {\n    padding: 10px 15px;\n  }\n  \n  .contact .php-email-form textarea {\n    padding: 12px 15px;\n  }\n  \n  .contact .php-email-form button[type=submit] {\n    background: #18d26e;\n    border: 0;\n    padding: 10px 30px;\n    color: #080808;\n    transition: 0.4s;\n    border-radius: 4px;\n    margin-top: 10px;\n  }\n  \n  .contact .php-email-form button[type=submit]:hover {\n    background: #15bb62;\n  }\n  .submit-status{\n    color: green;\n    text-align: center;\n    font-size: 25px;\n  }\n  \n  @keyframes animate-loading {\n    0% {\n      transform: rotate(0deg);\n    }\n  \n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
